import { Tab } from '../../../../../modals/product/ProductModal';

export default {
  title: 'Nouveau produit',
  tabs: {
    [Tab.General]: 'Général',
    [Tab.NutritionInfo]: 'Infos nutritionnelles',
  },
  form: {
    categories: {
      label: 'Catégories',
    },
    printer: {
      label: 'Imprimante',
    },
    name: {
      label: 'Nom',
      placeholder: 'Cheeseburger',
    },
    description: {
      label: 'Description',
      placeholder: '180g de steak haché, salade, tomates, concombres, jalapeños et sauce yuppi',
    },
    external_id: {
      label: 'Réf. {{integration}}',
      placeholder: 'ex. référence SKU HubRise',
      read_only_hint:
        'Modifiable uniquement si une intégration HubRise est connectée et la sync du menu est désactivée.',
    },
    price: {
      label: 'Prix de base',
    },
    has_smart_pricing: {
      label: 'Prix spéciaux pour le retrait et la livraison',
    },
    pickup_price: {
      label: 'Prix retrait',
      placeholder: 'Non spécifié',
    },
    delivery_price: {
      label: 'Prix livraison',
      placeholder: 'Non spécifié',
    },
    image: {
      label: 'Image (optionnelle)',
    },
    has_combo_tax: {
      label: 'Taxe combo',
    },
    is_available: {
      label: 'En stock',
      subtitle: 'Affiché au menu',
    },
    is_visible: {
      label: 'Visible',
      title: 'Visible au menu',
      subtitle_on: 'Les clients peuvent voir cet article',
      subtitle_off: 'Masqué pour tous les clients',
    },
    is_available_for_pickup: {
      label: 'Disponible en retrait',
      subtitle_on: 'Les clients peuvent commander en retrait',
      subtitle_off: 'Masqué du menu retrait',
    },
    is_available_for_delivery: {
      label: 'Disponible en livraison',
      subtitle_on: 'Les clients peuvent commander en livraison',
      subtitle_off: 'Masqué du menu livraison',
    },
    modifiers: {
      label: 'Modificateurs',
    },
  },
  labels: {
    smart_pricing_update_warning:
      'En mettant à jour, toutes les règles de tarification intelligente existantes pour ce produit seront réécrites.',
    smart_pricing_remove_warning:
      "Après l'enregistrement, toutes les règles de tarification intelligente existantes pour ce produit seront supprimées.",
  },
  availability: {
    title: 'Disponibilité',
    helper:
      'La visibilité est le commutateur principal. Désactivez un canal pour masquer cet article aux clients (retrait ou livraison) sans le retirer du menu.',
    status: {
      both: 'Les deux canaux',
      pickup_only: 'Retrait uniquement',
      delivery_only: 'Livraison uniquement',
      hidden: 'Masqué',
      no_channels: 'Aucun canal',
    },
    warning: {
      no_channels:
        "Cet article est visible mais n'est disponible sur aucun canal — les clients ne pourront pas le commander.",
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Retrait uniquement',
      delivery_only: 'Livraison uniquement',
      no_channels: 'Aucun canal',
    },
  },
  buttons: {
    save: 'Enregistrer',
    close: 'Fermer',
  },
  toasts: {
    changes_got_saved: 'Les modifications ont été enregistrées avec succès !',
  },
};
